var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"p-slide_menu--list"},_vm._l((_vm.genres),function(genre,i){return _c('li',{key:i},[_c('a',{staticClass:"p-slide_menu--category_link",attrs:{"href":_vm.linkUrl(genre)}},[_c('span',[_vm._v(_vm._s(genre.name))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }